import * as cnts from './constants';
import * as cnt from '../../master-template/__storeFiles__/constants';

export function updateSecondaryTemplateProps(payload) {
  return { type: cnts.UPDATE_TEMPLATE_PROPS, payload };
}

export function renameTemplate(payload) {
  return { type: cnts.RENAME_TEMPLATE, payload };
}

export function deleteTemplate(payload) {
  return { type: cnts.DELETE_TEMPLATE, payload };
}

export function createTemplate() {
  return { type: cnts.CREATE };
}

export function typeName({ target: { value } }) {
  return { type: cnts.TYPE_NAME, payload: value };
}



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template-list/__storeFiles__/actions.js